import { Link } from 'react-router-dom';
import { useTranslation } from '@eti/providers';
import { Button, Inline, Stack, Text } from '@etg/wings';
import { routes } from '../../../constants/routesAndApisConstants';
import TitledCard from '../../../common/components/TitledCard';

const Refund = () => {
  const { t } = useTranslation();

  return (
    <TitledCard data-testid="contact-us-refund-section" title={t('ContactUs.RefundSection.Title')}>
      <Stack>
        <Text asHtml>{t('ContactUs.RefundSection.Description')}</Text>
        <Inline align="start">
          <Button
            as={Link}
            data-testid="contactUs-refundStatus-button"
            to={routes.ORDER_LIST}
            variant="secondary"
          >
            {t('ContactUs.RefundSection.Button')}
          </Button>
        </Inline>
      </Stack>
    </TitledCard>
  );
};

export default Refund;
